
export default class LocData {
    // !!! reminder put POTA PARK marker layer LAST so it shows up on top of 
    // boundary geometry !!
    static data = {
        'data':
        {
            'US-AK': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StateAK.geojson' },
                { title: 'Parks', file: 'parks-US-AK.geojson' },
            ],
            'US-AL': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS4_0_StateAL.geojson' },
                { title: 'TOT NHT', file: '..\/US-common\/tot.geojson' },
                { title: 'Parks', file: 'parks-US-AL.geojson' },
                { title: "Summits W4A/CP", file: "W4A--CP.geojson" },
                { title: "Summits W4A/HR", file: "W4A--HR.geojson" },
                { title: "Summits W4A/PT", file: "W4A--PT.geojson" },
                { title: "Summits W4A/VR", file: "W4A--VR.geojson" },
            ],
            'US-AR': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US Des', file: 'PADUS3_0Designation_StateAR.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StateAR.geojson' },
                { title: 'TOT NHT', file: '..\/US-common\/tot.geojson' },
                { title: 'BFO NHT', file: '..\/US-common\/butterfield_ovrlnd_nht.geojson' },
                { title: 'Parks', file: 'parks-US-AR.geojson' },
                { title: "Summits W5A/BR", file: "W5A--BR.geojson" },
                { title: "Summits W5A/CA", file: "W5A--CA.geojson" },
                { title: "Summits W5A/CS", file: "W5A--CS.geojson" },
                { title: "Summits W5A/MA", file: "W5A--MA.geojson" },
                { title: "Summits W5A/OA", file: "W5A--OA.geojson" },
                { title: "Summits W5A/OH", file: "W5A--OH.geojson" },
                { title: "Summits W5A/OZ", file: "W5A--OZ.geojson" },
                { title: "Summits W5A/PT", file: "W5A--PT.geojson" },
            ],
            'US-AZ': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US', file: 'PADUS3_0Combined_StateAZ.geojson' },
                { title: 'OLSP NHT', file: '..\/US-common\/old_spanish_nht.geojson' },
                { title: 'BFO NHT', file: '..\/US-common\/butterfield_ovrlnd_nht.geojson' },
                { title: 'Parks', file: 'parks-US-AZ.geojson' },
                { title: "Summits W7A/AE", file: "W7A--AE.geojson" },
                { title: "Summits W7A/AP", file: "W7A--AP.geojson" },
                { title: "Summits W7A/AW", file: "W7A--AW.geojson" },
                { title: "Summits W7A/CN", file: "W7A--CN.geojson" },
                { title: "Summits W7A/CO", file: "W7A--CO.geojson" },
                { title: "Summits W7A/CS", file: "W7A--CS.geojson" },
                { title: "Summits W7A/GI", file: "W7A--GI.geojson" },
                { title: "Summits W7A/GM", file: "W7A--GM.geojson" },
                { title: "Summits W7A/GR", file: "W7A--GR.geojson" },
                { title: "Summits W7A/MN", file: "W7A--MN.geojson" },
                { title: "Summits W7A/MS", file: "W7A--MS.geojson" },
                { title: "Summits W7A/NA", file: "W7A--NA.geojson" },
                { title: "Summits W7A/NM", file: "W7A--NM.geojson" },
                { title: "Summits W7A/PE", file: "W7A--PE.geojson" },
                { title: "Summits W7A/PN", file: "W7A--PN.geojson" },
                { title: "Summits W7A/PW", file: "W7A--PW.geojson" },
                { title: "Summits W7A/PZ", file: "W7A--PZ.geojson" },
                { title: "Summits W7A/SC", file: "W7A--SC.geojson" },
                { title: "Summits W7A/SM", file: "W7A--SM.geojson" },
                { title: "Summits W7A/YU", file: "W7A--YU.geojson" },
                { title: "Summits W7A/YV", file: "W7A--YV.geojson" },
            ],
            'US-CA': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StateCA.geojson' },
                { title: 'Community', file: 'california_state_parks.geojson' },
                { title: 'CALI NHT', file: '..\/US-common\/cali_nht.geojson' },
                { title: 'OLSP NHT', file: '..\/US-common\/old_spanish_nht.geojson' },
                { title: 'BFO NHT', file: '..\/US-common\/butterfield_ovrlnd_nht.geojson' },
                { title: 'Parks', file: 'parks-US-CA.geojson' },
                { title: "Summits W6/CC", file: "W6--CC.geojson" },
                { title: "Summits W6/CD", file: "W6--CD.geojson" },
                { title: "Summits W6/CN", file: "W6--CN.geojson" },
                { title: "Summits W6/CT", file: "W6--CT.geojson" },
                { title: "Summits W6/CV", file: "W6--CV.geojson" },
                { title: "Summits W6/IN", file: "W6--IN.geojson" },
                { title: "Summits W6/NC", file: "W6--NC.geojson" },
                { title: "Summits W6/ND", file: "W6--ND.geojson" },
                { title: "Summits W6/NE", file: "W6--NE.geojson" },
                { title: "Summits W6/NS", file: "W6--NS.geojson" },
                { title: "Summits W6/NW", file: "W6--NW.geojson" },
                { title: "Summits W6/SC", file: "W6--SC.geojson" },
                { title: "Summits W6/SD", file: "W6--SD.geojson" },
                { title: "Summits W6/SN", file: "W6--SN.geojson" },
                { title: "Summits W6/SS", file: "W6--SS.geojson" },
                { title: "Summits W6/WH", file: "W6--WH.geojson" },
            ],
            'US-CO': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS4_0_StateCO.geojson' },
                { title: 'OLSP NHT', file: '..\/US-common\/old_spanish_nht.geojson' },
                { title: 'SAFE NHT', file: '..\/US-common\/safe.geojson' },
                { title: 'Parks', file: 'parks-US-CO.geojson' },
                { title: "Summits W0C/FR", file: "W0C--FR.geojson" },
                { title: "Summits W0C/LG", file: "W0C--LG.geojson" },
                { title: "Summits W0C/MZ", file: "W0C--MZ.geojson" },
                { title: "Summits W0C/PR", file: "W0C--PR.geojson" },
                { title: "Summits W0C/RG", file: "W0C--RG.geojson" },
                { title: "Summits W0C/RP", file: "W0C--RP.geojson" },
                { title: "Summits W0C/SC", file: "W0C--SC.geojson" },
                { title: "Summits W0C/SJ", file: "W0C--SJ.geojson" },
                { title: "Summits W0C/SL", file: "W0C--SL.geojson" },
                { title: "Summits W0C/SM", file: "W0C--SM.geojson" },
                { title: "Summits W0C/SP", file: "W0C--SP.geojson" },
                { title: "Summits W0C/SR", file: "W0C--SR.geojson" },
                { title: "Summits W0C/UR", file: "W0C--UR.geojson" },
                { title: "Summits W0C/WE", file: "W0C--WE.geojson" },
            ],
            'US-CT': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'AT', file: '..\/US-common\/at.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS4_0_State_CT.geojson' },
                { title: 'Parks', file: 'parks-US-CT.geojson' },
                { title: "Summits W1/CB", file: "W1--CB.geojson" },
                { title: "Summits W1/HH", file: "W1--HH.geojson" },
                { title: "Summits W1/MR", file: "W1--MR.geojson" },
            ],
            'US-DC': [
                { title: 'WARO NHT', file: '..\/US-common\/waro.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StateDC.geojson' },
                { title: 'Parks', file: 'parks-US-DC.geojson' },
            ],
            'US-DE': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS4_0_StateDE.geojson' },
                { title: 'Parks', file: 'parks-US-DE.geojson' },
            ],
            'US-FL': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS4_0_StateFL.geojson' },
                { title: 'FL NST', file: 'fl_nst2.geojson' },
                { title: 'Parks', file: 'parks-US-FL.geojson' },
            ],
            'US-GA': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'GA DNR', file: 'new_dnr20a.geojson' },
                { title: 'PAD-US', file: 'new_PAD1.geojson' },
                { title: 'AT', file: '..\/US-common\/at.geojson' },
                { title: 'TOT NHT', file: '..\/US-common\/tot.geojson' },
                { title: 'COP', file: 'cop3.geojson' },
                { title: 'Parks', file: 'parks-US-GA.geojson' },
                
                { title: 'Summits W4G/CE', file: 'W4G--CE.geojson' },
                { title: 'Summits W4G/HC', file: 'W4G--HC.geojson' },
                { title: 'Summits W4G/NG', file: 'W4G--NG.geojson' }
            ],
            'US-HI': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US', file: 'PADUS4_0_StateHI.geojson' },
                { title: 'Parks', file: 'parks-US-HI.geojson' },
            ],
            'US-IA': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'LC NHT', file: '..\/US-common\/lc_nht.geojson' },
                { title: 'MP NHT', file: '..\/US-common\/Mormon_Pioneer_NHT.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StateIA.geojson' },
                { title: 'Parks', file: 'parks-US-IA.geojson' },
                { title: "Summits W0I/IA", file: "W0I--IA.geojson" },
            ],
            'US-ID': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US', file: 'PADUS3_0Combined_StateID.geojson' },
                { title: 'ICE_AGE', file: '..\/US-common\/ice_age_trail2.geojson' },
                { title: 'Parks', file: 'parks-US-ID.geojson' },
                { title: "Summits W7I/BC", file: "W7I--BC.geojson" },
                { title: "Summits W7I/BL", file: "W7I--BL.geojson" },
                { title: "Summits W7I/CI", file: "W7I--CI.geojson" },
                { title: "Summits W7I/CU", file: "W7I--CU.geojson" },
                { title: "Summits W7I/ER", file: "W7I--ER.geojson" },
                { title: "Summits W7I/IC", file: "W7I--IC.geojson" },
                { title: "Summits W7I/LE", file: "W7I--LE.geojson" },
                { title: "Summits W7I/NI", file: "W7I--NI.geojson" },
                { title: "Summits W7I/NP", file: "W7I--NP.geojson" },
                { title: "Summits W7I/SI", file: "W7I--SI.geojson" },
                { title: "Summits W7I/SR", file: "W7I--SR.geojson" },
                { title: "Summits W7I/VC", file: "W7I--VC.geojson" },
            ],
            'US-IL': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StateIL.geojson' },
                { title: 'Community', file: 'illinois_state_parks.geojson' },
                { title: 'TOT NHT', file: '..\/US-common\/tot.geojson' },
                { title: 'MP NHT', file: '..\/US-common\/Mormon_Pioneer_NHT.geojson' },
                { title: 'Parks', file: 'parks-US-IL.geojson' },
                { title: "Summits W9/IL", file: "W9--IL.geojson" },
            ],
            'US-IN': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US', file: 'PADUS4_0_StateIN.geojson' },
                { title: 'Community', file: 'IN_DNR_Properties.geojson' },
                { title: 'Parks', file: 'parks-US-IN.geojson' },
                { title: "Summits W9/IN", file: "W9--IN.geojson" },
            ],
            'US-KH': [
                { title: 'Parks', file: 'parks-US-KH1.geojson' },
            ],
            'US-KP': [
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StatePR.geojson' },
                { title: 'Parks KP4', file: 'parks-US-KP4.geojson' },
                { title: 'Parks KP1', file: 'parks-US-KP1.geojson' },
                { title: 'Parks KP5', file: 'parks-US-KP5.geojson' },
            ],
            'US-KS': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StateKS.geojson' },
                { title: 'PE NHT', file: '..\/US-common\/Pony_Express_NHT.geojson' },
                { title: 'LC NHT', file: '..\/US-common\/lc_nht.geojson' },
                { title: 'SAFE NHT', file: '..\/US-common\/safe.geojson' },
                { title: 'Parks', file: 'parks-US-KS.geojson' },
            ],
            'US-KY': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StateKY.geojson' },
                { title: 'LC NHT', file: '..\/US-common\/lc_nht.geojson' },
                { title: 'TOT NHT', file: '..\/US-common\/tot.geojson' },
                { title: 'Parks', file: 'parks-US-KY.geojson' },
                { title: "Summits W4K/EC", file: "W4K--EC.geojson" },
                { title: "Summits W4K/KA", file: "W4K--KA.geojson" },
                { title: "Summits W4K/PR", file: "W4K--PR.geojson" },
            ],
            'US-LA': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS4_0_StateLA.geojson' },
                { title: 'ELCA_LT NHT', file: '..\/US-common\/los_tejas.geojson' },
                { title: 'Parks', file: 'parks-US-LA.geojson' },
            ],
            'US-MA': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'AT', file: '..\/US-common\/at.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StateMA.geojson' },
                { title: 'Parks', file: 'parks-US-MA.geojson' },
                { title: "Summits W1/CR", file: "W1--CR.geojson" },
                { title: "Summits W1/MB", file: "W1--MB.geojson" },
            ],
            'US-MD': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'AT', file: '..\/US-common\/at.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS4_0_StateMD.geojson' },
                { title: 'Parks', file: 'parks-US-MD.geojson' },
                { title: "Summits W3/CT", file: "W3--CT.geojson" },
                { title: "Summits W3/WE", file: "W3--WE.geojson" },
            ],
            'US-ME': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'AT', file: '..\/US-common\/at.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StateME.geojson' },
                { title: 'Parks', file: 'parks-US-ME.geojson' },
                { title: "Summits W1/AM", file: "W1--AM.geojson" },
                { title: "Summits W1/DI", file: "W1--DI.geojson" },
                { title: "Summits W1/EM", file: "W1--EM.geojson" },
            ],
            'US-MI': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'NCT NST', file: '..\/US-common\/nct_nst.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StateMI.geojson' },
                { title: 'Community', file: 'MI_DNR_Parks_Unit_Boundary.geojson' },
                { title: 'Parks', file: 'parks-US-MI.geojson' },
                { title: "Summits W8M/LP", file: "W8M--LP.geojson" },
                { title: "Summits W8M/UP", file: "W8M--UP.geojson" },
            ],
            'US-MN': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'NCT NST', file: '..\/US-common\/nct_nst.geojson' },
                { title: 'PAS-US Fee', file: 'PADUS4_0_StateMN.geojson' },
                { title: 'Community', file: 'minnesota_state_parks.geojson' },
                { title: 'MNRRA', file: 'mnrra.geojson' },
                { title: 'Parks', file: 'parks-US-MN.geojson' },
                { title: "Summits W0M/ES", file: "W0M--ES.geojson" },
                { title: "Summits W0M/SF", file: "W0M--SF.geojson" },
                { title: "Summits W0M/SP", file: "W0M--SP.geojson" },
            ],
            'US-MO': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAS-US Fee', file: 'PADUS3_0Fee_StateMO.geojson' },
                { title: 'TOT NHT', file: '..\/US-common\/tot.geojson' },
                { title: 'SAFE NHT', file: '..\/US-common\/safe.geojson' },
                { title: 'BFO NHT', file: '..\/US-common\/butterfield_ovrlnd_nht.geojson' },
                { title: 'Parks', file: 'parks-US-MO.geojson' },
                { title: "Summits W0M/ES ", file: "W0M--ES.geojson" },
                { title: "Summits W0M/SF ", file: "W0M--SF.geojson" },
                { title: "Summits W0M/SP ", file: "W0M--SP.geojson" },
            ],
            'US-MS': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StateMS.geojson' },
                { title: 'Parks', file: 'parks-US-MS.geojson' },
                { title: "Summits W5M/MS ", file: "W5M--MS.geojson" },
            ],
            'US-MT': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS4_0_StateMT.geojson' },
                { title: 'ICE_AGE', file: '..\/US-common\/ice_age_trail2.geojson' },
                { title: 'Parks', file: 'parks-US-MT.geojson' },
                { title: "Summits W7M/BE ", file: "W7M--BE.geojson" },
                { title: "Summits W7M/BR ", file: "W7M--BR.geojson" },
                { title: "Summits W7M/CL ", file: "W7M--CL.geojson" },
                { title: "Summits W7M/FN ", file: "W7M--FN.geojson" },
                { title: "Summits W7M/FS ", file: "W7M--FS.geojson" },
                { title: "Summits W7M/GA ", file: "W7M--GA.geojson" },
                { title: "Summits W7M/GR ", file: "W7M--GR.geojson" },
                { title: "Summits W7M/HB ", file: "W7M--HB.geojson" },
                { title: "Summits W7M/LI ", file: "W7M--LI.geojson" },
                { title: "Summits W7M/LM ", file: "W7M--LM.geojson" },
                { title: "Summits W7M/LO ", file: "W7M--LO.geojson" },
                { title: "Summits W7M/NF ", file: "W7M--NF.geojson" },
                { title: "Summits W7M/PN ", file: "W7M--PN.geojson" },
                { title: "Summits W7M/PS ", file: "W7M--PS.geojson" },
                { title: "Summits W7M/RC ", file: "W7M--RC.geojson" },
                { title: "Summits W7M/SF ", file: "W7M--SF.geojson" },
            ],
            'US-NC': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'TOT NHT', file: '..\/US-common\/tot.geojson' },
                { title: 'AT', file: '..\/US-common\/at.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StateNC.geojson' },
                { title: 'Parks', file: 'parks-US-NC.geojson' },
                { title: "Summits W4C/CM ", file: "W4C--CM.geojson" },
                { title: "Summits W4C/EM ", file: "W4C--EM.geojson" },
                { title: "Summits W4C/EP ", file: "W4C--EP.geojson" },
                { title: "Summits W4C/WM ", file: "W4C--WM.geojson" },
                { title: "Summits W4C/WP ", file: "W4C--WP.geojson" },
            ],
            'US-ND': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'NCT NST', file: '..\/US-common\/nct_nst.geojson' },
                { title: 'PAD-US', file: 'PADUS3_0Combined_StateND.geojson' },
                { title: 'Parks', file: 'parks-US-ND.geojson' },
                { title: "Summits W0D/ND ", file: "W0D--ND.geojson" },
            ],
            'US-NE': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'MP NHT', file: '..\/US-common\/Mormon_Pioneer_NHT.geojson' },
                { title: 'LC NHT', file: '..\/US-common\/lc_nht.geojson' },
                { title: 'PE NHT', file: '..\/US-common\/Pony_Express_NHT.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StateNE.geojson' },
                { title: 'Community', file: 'nebraska_state_parks.geojson' },
                { title: 'Parks', file: 'parks-US-NE.geojson' },
                { title: "Summits W0N/PH ", file: "W0N--PH.geojson" },
                { title: "Summits W0N/SH ", file: "W0N--SH.geojson" },
            ],
            'US-NH': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'AT', file: '..\/US-common\/at.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StateNH.geojson' },
                { title: 'Parks', file: 'parks-US-NH.geojson' },
                { title: "Summits W1/HA ", file: "W1--HA.geojson" },
                { title: "Summits W1/MV ", file: "W1--MV.geojson" },
                { title: "Summits W1/NL ", file: "W1--NL.geojson" },
            ],
            'US-NJ': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'AT', file: '..\/US-common\/at.geojson' },
                { title: 'WARO NHT', file: '..\/US-common\/waro.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StateNJ.geojson' },
                { title: 'Parks', file: 'parks-US-NJ.geojson' },
                { title: "Summits W2/NJ ", file: "W2--NJ.geojson" },
            ],
            'US-NM': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US', file: 'PADUS3_0Combined_StateNM.geojson' },
                { title: 'Community', file: 'NMStateParks.geojson' },
                { title: 'OLSP NHT', file: '..\/US-common\/old_spanish_nht.geojson' },
                { title: 'BFO NHT', file: '..\/US-common\/butterfield_ovrlnd_nht.geojson' },
                { title: 'ELCA_TA NHT', file: '..\/US-common\/tierra_adentro.geojson' },
                { title: 'SAFE NHT', file: '..\/US-common\/safe.geojson' },
                { title: 'Parks', file: 'parks-US-NM.geojson' },
                { title: "Summits W5N/AI ", file: "W5N--AI.geojson" },
                { title: "Summits W5N/AP ", file: "W5N--AP.geojson" },
                { title: "Summits W5N/BA ", file: "W5N--BA.geojson" },
                { title: "Summits W5N/BL ", file: "W5N--BL.geojson" },
                { title: "Summits W5N/BU ", file: "W5N--BU.geojson" },
                { title: "Summits W5N/CB ", file: "W5N--CB.geojson" },
                { title: "Summits W5N/CC ", file: "W5N--CC.geojson" },
                { title: "Summits W5N/CD ", file: "W5N--CD.geojson" },
                { title: "Summits W5N/CM ", file: "W5N--CM.geojson" },
                { title: "Summits W5N/CN ", file: "W5N--CN.geojson" },
                { title: "Summits W5N/CO ", file: "W5N--CO.geojson" },
                { title: "Summits W5N/CU ", file: "W5N--CU.geojson" },
                { title: "Summits W5N/DA ", file: "W5N--DA.geojson" },
                { title: "Summits W5N/EL ", file: "W5N--EL.geojson" },
                { title: "Summits W5N/FL ", file: "W5N--FL.geojson" },
                { title: "Summits W5N/GF ", file: "W5N--GF.geojson" },
                { title: "Summits W5N/GW ", file: "W5N--GW.geojson" },
                { title: "Summits W5N/HT ", file: "W5N--HT.geojson" },
                { title: "Summits W5N/MG ", file: "W5N--MG.geojson" },
                { title: "Summits W5N/MI ", file: "W5N--MI.geojson" },
                { title: "Summits W5N/MO ", file: "W5N--MO.geojson" },
                { title: "Summits W5N/NL ", file: "W5N--NL.geojson" },
                { title: "Summits W5N/OR ", file: "W5N--OR.geojson" },
                { title: "Summits W5N/OT ", file: "W5N--OT.geojson" },
                { title: "Summits W5N/PA ", file: "W5N--PA.geojson" },
                { title: "Summits W5N/PL ", file: "W5N--PL.geojson" },
                { title: "Summits W5N/PO ", file: "W5N--PO.geojson" },
                { title: "Summits W5N/PW ", file: "W5N--PW.geojson" },
                { title: "Summits W5N/RO ", file: "W5N--RO.geojson" },
                { title: "Summits W5N/SC ", file: "W5N--SC.geojson" },
                { title: "Summits W5N/SE ", file: "W5N--SE.geojson" },
                { title: "Summits W5N/SG ", file: "W5N--SG.geojson" },
                { title: "Summits W5N/SI ", file: "W5N--SI.geojson" },
                { title: "Summits W5N/SL ", file: "W5N--SL.geojson" },
                { title: "Summits W5N/SM ", file: "W5N--SM.geojson" },
                { title: "Summits W5N/SR ", file: "W5N--SR.geojson" },
                { title: "Summits W5N/SS ", file: "W5N--SS.geojson" },
            ],
            'US-NV': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US Des', file: 'PADUS3_0Designation_StateNV.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StateNV.geojson' },
                { title: 'PE NHT', file: '..\/US-common\/Pony_Express_NHT.geojson' },
                { title: 'OLSP NHT', file: '..\/US-common\/old_spanish_nht.geojson' },
                { title: 'Parks', file: 'parks-US-NV.geojson' },
                { title: "Summits W7N/CK ", file: "W7N--CK.geojson" },
                { title: "Summits W7N/EL ", file: "W7N--EL.geojson" },
                { title: "Summits W7N/EM ", file: "W7N--EM.geojson" },
                { title: "Summits W7N/EN ", file: "W7N--EN.geojson" },
                { title: "Summits W7N/ES ", file: "W7N--ES.geojson" },
                { title: "Summits W7N/HU ", file: "W7N--HU.geojson" },
                { title: "Summits W7N/LN ", file: "W7N--LN.geojson" },
                { title: "Summits W7N/NN ", file: "W7N--NN.geojson" },
                { title: "Summits W7N/NS ", file: "W7N--NS.geojson" },
                { title: "Summits W7N/PC ", file: "W7N--PC.geojson" },
                { title: "Summits W7N/TR ", file: "W7N--TR.geojson" },
                { title: "Summits W7N/WC ", file: "W7N--WC.geojson" },
                { title: "Summits W7N/WP ", file: "W7N--WP.geojson" },
            ],
            'US-NY': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US', file: 'PADUS3_0Fee_StateNY.geojson' },
                { title: 'Community', file: 'new_york_state_parks.geojson' },
                { title: 'EC', file: 'eriecanalway_sim.geojson' },
                { title: 'AT', file: '..\/US-common\/at.geojson' },
                { title: 'NCT NST', file: '..\/US-common\/nct_nst.geojson' },
                { title: 'Parks', file: 'parks-US-NY.geojson' },
                { title: "Summits W2/EH ", file: "W2--EH.geojson" },
                { title: "Summits W2/GA ", file: "W2--GA.geojson" },
                { title: "Summits W2/GC ", file: "W2--GC.geojson" },
                { title: "Summits W2/WE ", file: "W2--WE.geojson" },

            ],
            'US-OH': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US', file: 'PADUS4_0_StateOH.geojson' },
                { title: 'LC NHT', file: '..\/US-common\/lc_nht.geojson' },
                { title: 'NCT NST', file: '..\/US-common\/nct_nst.geojson' },
                { title: 'Parks', file: 'parks-US-OH.geojson' },
                { title: "Summits W8O/CT ", file: "W8O--CT.geojson" },
                { title: "Summits W8O/NE ", file: "W8O--NE.geojson" },
                { title: "Summits W8O/SE ", file: "W8O--SE.geojson" },
                { title: "Summits W8O/SW ", file: "W8O--SW.geojson" },
            ],
            'US-OK': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US', file: 'PADUS3_0Combined_StateOK.geojson' },
                { title: 'TOT NHT', file: '..\/US-common\/tot.geojson' },
                { title: 'BFO NHT', file: '..\/US-common\/butterfield_ovrlnd_nht.geojson' },
                { title: 'SAFE NHT', file: '..\/US-common\/safe.geojson' },
                { title: 'Parks', file: 'parks-US-OK.geojson' },
                { title: "Summits W5O/BS ", file: "W5O--BS.geojson" },
                { title: "Summits W5O/KI ", file: "W5O--KI.geojson" },
                { title: "Summits W5O/OU ", file: "W5O--OU.geojson" },
                { title: "Summits W5O/QA ", file: "W5O--QA.geojson" },
                { title: "Summits W5O/SO ", file: "W5O--SO.geojson" },
                { title: "Summits W5O/WI ", file: "W5O--WI.geojson" },
                { title: "Summits W5O/WO ", file: "W5O--WO.geojson" },
            ],
            'US-OR': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US', file: 'PADUS4_0_State_OR.geojson' },
                { title: 'CALI NHT', file: '..\/US-common\/cali_nht.geojson' },
                { title: 'LC NHT', file: '..\/US-common\/lc_nht.geojson' },
                { title: 'OR NHT', file: '..\/US-common\/or_nht.geojson' },
                { title: 'ICE_AGE', file: '..\/US-common\/ice_age_trail2.geojson' },
                { title: 'Parks', file: 'parks-US-OR.geojson' },
                { title: "Summits W7O/CC ", file: "W7O--CC.geojson" },
                { title: "Summits W7O/CE ", file: "W7O--CE.geojson" },
                { title: "Summits W7O/CM ", file: "W7O--CM.geojson" },
                { title: "Summits W7O/CN ", file: "W7O--CN.geojson" },
                { title: "Summits W7O/CS ", file: "W7O--CS.geojson" },
                { title: "Summits W7O/NC ", file: "W7O--NC.geojson" },
                { title: "Summits W7O/NE ", file: "W7O--NE.geojson" },
                { title: "Summits W7O/SC ", file: "W7O--SC.geojson" },
                { title: "Summits W7O/SE ", file: "W7O--SE.geojson" },
                { title: "Summits W7O/WV ", file: "W7O--WV.geojson" },
            ],
            'US-PA': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'NCT NST', file: '..\/US-common\/nct_nst.geojson' },
                { title: 'AT', file: '..\/US-common\/at.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StatePA.geojson' },
                { title: 'Parks', file: 'parks-US-PA.geojson' },
                { title: "Summits W3/ER ", file: "W3--ER.geojson" },
                { title: "Summits W3/PD ", file: "W3--PD.geojson" },
                { title: "Summits W3/PH ", file: "W3--PH.geojson" },
                { title: "Summits W3/PO ", file: "W3--PO.geojson" },
                { title: "Summits W3/PT ", file: "W3--PT.geojson" },
                { title: "Summits W3/PW ", file: "W3--PW.geojson" },
                { title: "Summits W3/SV ", file: "W3--SV.geojson" },
            ],
            'US-RI': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StateRI.geojson' },
                { title: 'Parks', file: 'parks-US-RI.geojson' },
            ],
            'US-SC': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StateSC.geojson' },
                { title: 'Parks', file: 'parks-US-SC.geojson' },
                { title: "Summits W4C/US ", file: "W4C--US.geojson" },
            ],
            'US-SD': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StateSD.geojson' },
                { title: 'Parks', file: 'parks-US-SD.geojson' },
                { title: "Summits W0D/BB ", file: "W0D--BB.geojson" },
                { title: "Summits W0D/ES ", file: "W0D--ES.geojson" },
                { title: "Summits W0D/MR ", file: "W0D--MR.geojson" },
                { title: "Summits W0D/NW ", file: "W0D--NW.geojson" },
            ],
            'US-TN': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'AT', file: '..\/US-common\/at.geojson' },
                { title: 'TOT NHT', file: '..\/US-common\/tot.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StateTN.geojson' },
                { title: 'Parks', file: 'parks-US-TN.geojson' },
                { title: "Summits W4T/CA ", file: "W4T--CA.geojson" },
                { title: "Summits W4T/NB ", file: "W4T--NB.geojson" },
                { title: "Summits W4T/RV ", file: "W4T--RV.geojson" },
                { title: "Summits W4T/SU ", file: "W4T--SU.geojson" },
            ],
            'US-TX': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US', file: 'PADUS4_0Fee_StateTX.geojson' },
                { title: 'BFO NHT', file: '..\/US-common\/butterfield_ovrlnd_nht.geojson' },
                { title: 'ELCA_TA NHT', file: '..\/US-common\/tierra_adentro.geojson' },
                { title: 'ELCA_LT NHT', file: '..\/US-common\/los_tejas.geojson' },
                { title: 'Parks', file: 'parks-US-TX.geojson' },
                { title: "Summits W5T/BG ", file: "W5T--BG.geojson" },
                { title: "Summits W5T/BO ", file: "W5T--BO.geojson" },
                { title: "Summits W5T/CE ", file: "W5T--CE.geojson" },
                { title: "Summits W5T/CH ", file: "W5T--CH.geojson" },
                { title: "Summits W5T/CI ", file: "W5T--CI.geojson" },
                { title: "Summits W5T/CR ", file: "W5T--CR.geojson" },
                { title: "Summits W5T/DE ", file: "W5T--DE.geojson" },
                { title: "Summits W5T/DH ", file: "W5T--DH.geojson" },
                { title: "Summits W5T/DN ", file: "W5T--DN.geojson" },
                { title: "Summits W5T/DW ", file: "W5T--DW.geojson" },
                { title: "Summits W5T/EA ", file: "W5T--EA.geojson" },
                { title: "Summits W5T/EF ", file: "W5T--EF.geojson" },
                { title: "Summits W5T/FR ", file: "W5T--FR.geojson" },
                { title: "Summits W5T/GL ", file: "W5T--GL.geojson" },
                { title: "Summits W5T/GU ", file: "W5T--GU.geojson" },
                { title: "Summits W5T/HA ", file: "W5T--HA.geojson" },
                { title: "Summits W5T/NT ", file: "W5T--NT.geojson" },
                { title: "Summits W5T/PB ", file: "W5T--PB.geojson" },
                { title: "Summits W5T/PU ", file: "W5T--PU.geojson" },
                { title: "Summits W5T/QU ", file: "W5T--QU.geojson" },
                { title: "Summits W5T/SB ", file: "W5T--SB.geojson" },
                { title: "Summits W5T/SD ", file: "W5T--SD.geojson" },
                { title: "Summits W5T/SN ", file: "W5T--SN.geojson" },
                { title: "Summits W5T/ST ", file: "W5T--ST.geojson" },
                { title: "Summits W5T/SV ", file: "W5T--SV.geojson" },
                { title: "Summits W5T/VH ", file: "W5T--VH.geojson" },
            ],
            'US-UT': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StateUT.geojson' },
                { title: 'PAD-US Des', file: 'PADUS3_0Designation_StateUT.geojson' },
                { title: 'OLSP NHT', file: '..\/US-common\/old_spanish_nht.geojson' },
                { title: 'MP NHT', file: '..\/US-common\/Mormon_Pioneer_NHT.geojson' },
                { title: 'Parks', file: 'parks-US-UT.geojson' },
                { title: "Summits W7U/BE ", file: "W7U--BE.geojson" },
                { title: "Summits W7U/BO ", file: "W7U--BO.geojson" },
                { title: "Summits W7U/CA ", file: "W7U--CA.geojson" },
                { title: "Summits W7U/CR ", file: "W7U--CR.geojson" },
                { title: "Summits W7U/DA ", file: "W7U--DA.geojson" },
                { title: "Summits W7U/DU ", file: "W7U--DU.geojson" },
                { title: "Summits W7U/DV ", file: "W7U--DV.geojson" },
                { title: "Summits W7U/EM ", file: "W7U--EM.geojson" },
                { title: "Summits W7U/GA ", file: "W7U--GA.geojson" },
                { title: "Summits W7U/GR ", file: "W7U--GR.geojson" },
                { title: "Summits W7U/IR ", file: "W7U--IR.geojson" },
                { title: "Summits W7U/JU ", file: "W7U--JU.geojson" },
                { title: "Summits W7U/KA ", file: "W7U--KA.geojson" },
                { title: "Summits W7U/MI ", file: "W7U--MI.geojson" },
                { title: "Summits W7U/MO ", file: "W7U--MO.geojson" },
                { title: "Summits W7U/NU ", file: "W7U--NU.geojson" },
                { title: "Summits W7U/PI ", file: "W7U--PI.geojson" },
                { title: "Summits W7U/RI ", file: "W7U--RI.geojson" },
                { title: "Summits W7U/SE ", file: "W7U--SE.geojson" },
                { title: "Summits W7U/SJ ", file: "W7U--SJ.geojson" },
                { title: "Summits W7U/SL ", file: "W7U--SL.geojson" },
                { title: "Summits W7U/SM ", file: "W7U--SM.geojson" },
                { title: "Summits W7U/SP ", file: "W7U--SP.geojson" },
                { title: "Summits W7U/SU ", file: "W7U--SU.geojson" },
                { title: "Summits W7U/TO ", file: "W7U--TO.geojson" },
                { title: "Summits W7U/UI ", file: "W7U--UI.geojson" },
                { title: "Summits W7U/UT ", file: "W7U--UT.geojson" },
                { title: "Summits W7U/WA ", file: "W7U--WA.geojson" },
                { title: "Summits W7U/WB ", file: "W7U--WB.geojson" },
                { title: "Summits W7U/WS ", file: "W7U--WS.geojson" },
                { title: "Summits W7U/WY ", file: "W7U--WY.geojson" },
            ],
            'US-VA': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'AT', file: '..\/US-common\/at.geojson' },
                { title: 'PAD-US Des', file: 'PADUS4_0_StateVA_Desig.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS4_0_StateVA.geojson' },
                { title: 'Community', file: 'VA_SP_Boundaries.geojson' },
                { title: 'Parks', file: 'parks-US-VA.geojson' },
                { title: "Summits W4V/AB ", file: "W4V--AB.geojson" },
                { title: "Summits W4V/BR ", file: "W4V--BR.geojson" },
                { title: "Summits W4V/FC ", file: "W4V--FC.geojson" },
                { title: "Summits W4V/GC ", file: "W4V--GC.geojson" },
                { title: "Summits W4V/HB ", file: "W4V--HB.geojson" },
                { title: "Summits W4V/LX ", file: "W4V--LX.geojson" },
                { title: "Summits W4V/RA ", file: "W4V--RA.geojson" },
                { title: "Summits W4V/SH ", file: "W4V--SH.geojson" },
                { title: "Summits W4V/WV ", file: "W4V--WV.geojson" },
            ],
            // no parks here 😢
            'US-VI': [
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StateVI.geojson' },
                { title: 'Parks', file: 'parks-US-VI.geojson' },
            ],
            'US-VT': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'AT', file: '..\/US-common\/at.geojson' },
                { title: 'NCT NST', file: '..\/US-common\/nct_nst.geojson' },
                { title: 'PAD-US', file: 'PADUS3_0Combined_StateVT.geojson' },
                { title: 'Parks', file: 'parks-US-VT.geojson' },
                { title: "Summits W1/GM ", file: "W1--GM.geojson" },
                { title: "Summits W1/NK ", file: "W1--NK.geojson" },
            ],
            'US-WA': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US', file: 'PADUS4_0_State_WA.geojson' },
                { title: 'ICE_AGE', file: '..\/US-common\/ice_age_trail2.geojson' },
                { title: 'LC NHT', file: '..\/US-common\/lc_nht.geojson' },
                { title: 'OR NHT', file: '..\/US-common\/or_nht.geojson' },
                { title: 'Parks', file: 'parks-US-WA.geojson' },
                { title: "Summits W7W/CH ", file: "W7W--CH.geojson" },
                { title: "Summits W7W/CW ", file: "W7W--CW.geojson" },
                { title: "Summits W7W/FR ", file: "W7W--FR.geojson" },
                { title: "Summits W7W/KG ", file: "W7W--KG.geojson" },
                { title: "Summits W7W/LC ", file: "W7W--LC.geojson" },
                { title: "Summits W7W/MC ", file: "W7W--MC.geojson" },
                { title: "Summits W7W/NO ", file: "W7W--NO.geojson" },
                { title: "Summits W7W/OK ", file: "W7W--OK.geojson" },
                { title: "Summits W7W/PL ", file: "W7W--PL.geojson" },
                { title: "Summits W7W/PO ", file: "W7W--PO.geojson" },
                { title: "Summits W7W/RS ", file: "W7W--RS.geojson" },
                { title: "Summits W7W/SK ", file: "W7W--SK.geojson" },
                { title: "Summits W7W/SN ", file: "W7W--SN.geojson" },
                { title: "Summits W7W/SO ", file: "W7W--SO.geojson" },
                { title: "Summits W7W/ST ", file: "W7W--ST.geojson" },
                { title: "Summits W7W/WE ", file: "W7W--WE.geojson" },
                { title: "Summits W7W/WH ", file: "W7W--WH.geojson" },
            ],
            'US-WI': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'NCT NST', file: '..\/US-common\/nct_nst.geojson' },
                { title: 'PAD-US Proc', file: 'PADUS3_0Proclamation_StateWI.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StateWI.geojson' },
                { title: 'PAD-US Des', file: 'PADUS3_0Designation_StateWI.geojson' },
                { title: 'Parks', file: 'parks-US-WI.geojson' },
            ],
            'US-WV': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'AT', file: '..\/US-common\/at.geojson' },
                { title: 'LC NHT', file: '..\/US-common\/lc_nht.geojson' },
                { title: 'PAD-US Fee', file: 'PADUS3_0Fee_StateWV.geojson' },
                { title: 'Parks', file: 'parks-US-WV.geojson' },
                { title: "Summits W8V/EP ", file: "W8V--EP.geojson" },
                { title: "Summits W8V/HM ", file: "W8V--HM.geojson" },
                { title: "Summits W8V/MC ", file: "W8V--MC.geojson" },
                { title: "Summits W8V/ML ", file: "W8V--ML.geojson" },
                { title: "Summits W8V/MV ", file: "W8V--MV.geojson" },
                { title: "Summits W8V/NP ", file: "W8V--NP.geojson" },
                { title: "Summits W8V/NR ", file: "W8V--NR.geojson" },
                { title: "Summits W8V/PH ", file: "W8V--PH.geojson" },
            ],
            'US-WY': [
                { title: 'Counties', file: 'counties.geojson' },
                { title: 'PAD-US', file: 'PADUS3_0Combined_StateWY.geojson' },
                { title: 'BLM', file: 'BLM_PADUS3_0Combined_StateWY.geojson' },
                { title: 'MP NHT', file: '..\/US-common\/Mormon_Pioneer_NHT.geojson' },
                { title: 'Parks', file: 'parks-US-WY.geojson' },
                { title: "Summits W7Y/EW ", file: "W7Y--EW.geojson" },
                { title: "Summits W7Y/FT ", file: "W7Y--FT.geojson" },
                { title: "Summits W7Y/NW ", file: "W7Y--NW.geojson" },
                { title: "Summits W7Y/PA ", file: "W7Y--PA.geojson" },
                { title: "Summits W7Y/SL ", file: "W7Y--SL.geojson" },
                { title: "Summits W7Y/SW ", file: "W7Y--SW.geojson" },
                { title: "Summits W7Y/TT ", file: "W7Y--TT.geojson" },
            ],
        }
    };
}
